import { render, staticRenderFns } from "./Mines.vue?vue&type=template&id=c4a5da3a&scoped=true"
import script from "./Mines.vue?vue&type=script&lang=js"
export * from "./Mines.vue?vue&type=script&lang=js"
import style0 from "./Mines.vue?vue&type=style&index=0&id=c4a5da3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a5da3a",
  null
  
)

export default component.exports